import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import Swiper, { Autoplay, Navigation, Pagination, SwiperOptions } from 'swiper';
import { OurProject } from 'src/app/models/firebase/our-project';
import { AuthService } from 'src/app/service/auth/auth.service';
import * as $ from 'jquery';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';
import { OurProjectsService } from 'src/app/service/our-projects/our-projects.service';

@Component({
  selector: 'app-our-projects',
  templateUrl: './our-projects.component.html',
  styleUrls: ['./our-projects.component.scss']
})
export class OurProjectsComponent implements OnInit {

    projects:OurProject[] = [];
    @Input() landingPageData: LandingPage;
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    swiperOptions: SwiperOptions = {
        modules: [Navigation, Pagination, Autoplay],
        speed: 9000,
        slidesPerView: 'auto',
        loop: true,
        observer: true,
        spaceBetween: 40,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        freeMode: true,
        preventInteractionOnTransition: true,
      };

    constructor(
        private authService: AuthService,
        private ourProjectsService: OurProjectsService,
    ){}

    async ngOnInit(): Promise<void>{
        this.projects = await this.ourProjectsService.getProjects(this.authService.projectId);
        setTimeout(() => {
            this.initSwiper();
        }, 500);
    }

    initSwiper(): void {
        if (this.projects.length > 3) {
          new Swiper('.swiper-2', this.swiperOptions);
          new Swiper('.swiper-3', {
            ...this.swiperOptions,
            autoplay: {
              delay: 1.3,
              disableOnInteraction: false,
              reverseDirection: true,
            },
          });
        }
    }
}
